import React from "react";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Link,
  Typography,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const TEMPLATE_URL =
  "https://ljs-dic-public-resources-dev.s3.ap-northeast-1.amazonaws.com/templates/account_import.xlsx";
const MAIL_ADDRESS = "dic-cosmo@tamada.co.jp";
const MAIL_SUBJECT = "災害対応システムへのアカウント登録依頼";
const MAIL_BODY = "貴社名:\nご担当者名:\n";

const mailtoHref = `mailto:${MAIL_ADDRESS}?subject=${encodeURIComponent(
  MAIL_SUBJECT
)}&body=${encodeURIComponent(MAIL_BODY)}`;

const theme = createTheme();

type AccountPreRegistrationProps = {
  onBack: () => void;
};

const AccountPreRegistration = ({ onBack }: AccountPreRegistrationProps) => {
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            mt: 4,
          }}
        >
          <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
            アカウント登録依頼方法
          </Typography>

          <Typography component="p" variant="body1" sx={{ mb: 1 }}>
            1. テンプレートファイルに必要事項を記入
          </Typography>
          <Link
            href={TEMPLATE_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ mb: 3, ml: 2 }}
          >
            テンプレートファイルはこちら
          </Link>

          <Typography component="p" variant="body1" sx={{ mb: 1 }}>
            2. 記入したファイルをこちらのメールに送信
          </Typography>
          <Link href={mailtoHref} sx={{ mb: 1, ml: 2 }}>
            {MAIL_ADDRESS}
          </Link>
          <Typography component="p" variant="body2" sx={{ mb: 2, ml: 2 }}>
            下記の件名、本文（貴社名、ご担当者名）にて、1で記入したExcelファイルを添付の上お送りください。
          </Typography>

          <Box sx={{ ml: 2, mb: 3 }}>
            <Typography component="p" variant="body1" sx={{ mb: 1 }}>
              件名
            </Typography>
            <Typography component="p" variant="body2" sx={{ mb: 2, ml: 2 }}>
              {MAIL_SUBJECT}
            </Typography>
            <Typography component="p" variant="body1" sx={{ mb: 1 }}>
              本文
            </Typography>
            <Typography
              component="p"
              variant="body2"
              sx={{ ml: 2, whiteSpace: "pre-line" }}
            >
              {`貴社名:\nご担当者名:`}
            </Typography>
          </Box>

          <Button onClick={onBack} fullWidth sx={{ mt: 1, mb: 2 }}>
            戻る
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default AccountPreRegistration;
